import { render, staticRenderFns } from "./RealEstateLandForm.vue?vue&type=template&id=b422c28a&"
import script from "./RealEstateLandForm.vue?vue&type=script&lang=js&"
export * from "./RealEstateLandForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports